import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useNotificationsModalContainerStyles = makeStyles((theme: Theme) => ({
    header: {
        position: "sticky",
        top: 0,
        zIndex: 1000,

        background: "#fff",
        borderBottom: `1px solid ${theme.palette.border.main}`,
    },
    menu: {
        width: 600,
        maxHeight: "80%",
        "& .MuiFormControlLabel-root": {
            marginLeft: 0,
            color: theme.palette.textGrey.main,
        },
        "& .MuiList-padding": {
            padding: 0,
        },
        "& .MuiListItem-root": {
            padding: theme.spacing(1.5, 0),
            paddingRight: 10,
            minHeight: 90,
            cursor: "default",
            "&:not(:last-child)": {
                borderBottom: `1px solid ${theme.palette.border.main}`,
            },
        },
    },
    smallText: {
        fontSize: 12,
    },
    new: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "100%",
        width: 10,
        height: 10,
    },
}));

export const useNotificationStyles = makeStyles((theme: Theme) => ({
    errorItem: {
        "&:hover": {
            backgroundColor: `${theme.palette.error.main}0D`,
        },
    },
    item: {
        "&:hover": {
            backgroundColor: theme.palette.grey[100],
        },
    },
    notification: {
        cursor: "pointer",
        padding: "10px",
        minHeight: "90px",
        justifyContent: "space-between",
        "&:not(:last-child)": {
            borderBottom: `1px solid ${theme.palette.border.main}`,
        },
        "&:active": {
            backgroundColor: theme.palette.grey[300],
            transition: theme.transitions.create(["background-color", "box-shadow"]),
        },
        width: "100%",
    },
    text: {
        fontSize: 14,
        whiteSpace: "pre-line",
    },
    dateContainer: {
        flexGrow: 1,
        minHeight: "100%",
    },
    date: {
        minHeight: "100%",
        fontSize: 12,
        color: "rgba(0, 0, 0, 0.54)",
    },
    newBackground: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 30,
        height: 30,
        borderRadius: "100%",
        "&:hover": {
            width: 30,
            height: 30,
            backgroundColor: theme.palette.grey[300],
        },
    },
    new: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "100%",
        width: 10,
        height: 10,
    },
    oldBackground: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 30,
        height: 30,
        borderRadius: "100%",
        "&:hover": {
            width: 30,
            height: 30,
            backgroundColor: theme.palette.grey[300],
        },
    },
    old: {
        width: 10,
        height: 10,
        borderRadius: "100%",
        "&:active": {
            backgroundColor: theme.palette.primary.main,
        },
        "&:hover": {
            backgroundColor: theme.palette.grey[500],
        },
    },
}));

export const useNotificationIconStyles = makeStyles((theme: Theme) => ({
    success: {
        color: theme.palette.success.main,
    },
    warning: {
        color: theme.palette.warning.main,
    },
}));
